// extracted by mini-css-extract-plugin
module.exports = {"BackgroundColor":"#f9edbc","TextColor":"#212121","FontFamily":"'Montserrat', sans-serif","FontBaseSize":"16px","FontScale":"4"};